var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8"},[_c('h2',[_vm._v("Главные блоки")]),_c('ul',{staticClass:"interface"},_vm._l((_vm.blocks),function(block){return _c('li',{key:block.id,style:({
            maxWidth: block.width * _vm.device * 25 + '%',
          })},[_c('div',{style:({
              paddingTop: (block.height / block.width) * 100 + '%',
            })},[_c('ul',{staticClass:"subinterface"},_vm._l((block.child),function(item){return _c('li',{key:item.id,style:({
                  maxWidth: item.width * 50 + '%',
                })},[_c('div',{style:({
                    paddingTop: (item.height / item.width) * 100 + '%',
                  })},[_c('a',[_c('img',{attrs:{"alt":'New Collection',"title":'New Collection',"src":item.img}})])])])}),0)])])}),0)])])])}
var staticRenderFns = []

export { render, staticRenderFns }